app.controller(
    'DistrictTranslationController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'DistrictService', 'HelperService', 'SideBarService', '$sce', '$translate', '$window', DistrictTranslationController]
);

function DistrictTranslationController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, DistrictService, HelperService, SideBarService, $sce, $translate, $window) {
    var vm = this;
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    $translate.use($rootScope.LangForInterface);

    $scope.quartier = {};
    $scope.edit = {};

    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.DescriptionToTranslate = {};
    vm.SelectedDescriptionStatusItem = {};
    vm.PreviousDescriptionStatusItem = {};

    vm.ActiveDescriptionVm =
       {
           Clients: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
           QualificationList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]
       };

    //Get Single 
    var promiseGetSingle = DistrictService.getDistrict($stateParams.id, $scope.CurrentLang, $rootScope.LangForTranslationDestination, $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    promiseGetSingle.then(function (t) {
        var res = t.data;
        vm.quartier = res;
        vm.quartierOrigin = angular.copy(vm.quartier);

        if (vm.quartier.DescriptionList.length > 0) {
            vm.ActiveDescriptionId = 0;
            vm.ActiveDescription = vm.quartier.DescriptionList[vm.ActiveDescriptionId];

            //load descriptionVm
            vm.GetDescriptionVm();

            //load translation description
            vm.GetDescriptionTranslated();
        }

        $rootScope.PlaceList = res.PlaceList;
        $rootScope.CurrentObjectId = res.CurrentDisctrict.DistrictId;
        $rootScope.CurrentPageType = $rootScope.EnumLinkType.District;
        $rootScope.CurrentObjectStatus = res.CurrentDistrictStatus;        
        $rootScope.Comments = res.CommentList;
        $rootScope.SideBar = res.SideBar;
        $rootScope.SideBar.CurrentObjectStatus = res.CurrentDistrictStatus;
        $rootScope.SideBar.StatusList = $rootScope.StatusList4WorkflowObjectSt;

        $rootScope.Clients = res.ClientList;
        $rootScope.ClassificationList = res.ClassificationList;

        //$scope.ChangeZoneById(vm.ParamZoneId);
    });


    $scope.UpdateDistrict = function UpdateDistrict() {
        DistrictService.UpdateDistrict(vm.quartier);
    };

    vm.UpdateDescription = function () {
        if (vm.SelectedDescriptionStatusItem != undefined) {
            vm.DescriptionToTranslate.StatusId = vm.SelectedDescriptionStatusItem.id;
        }
        else {
            vm.DescriptionToTranslate.StatusId = 17;
        }
        if (vm.NewDescription) {
            HelperService.AddDescription(vm.DescriptionToTranslate)
            .then(function (data) {
                vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;
            });            
        }
        else {
            HelperService.UpdateDescription(vm.DescriptionToTranslate)
                .then(function (data) {

                });
        }
    }

    vm.UpdateDescriptionStatusId = function () {
        if (vm.SelectedDescriptionStatusItem != undefined) {
            vm.DescriptionToTranslate.StatusId = vm.SelectedDescriptionStatusItem.id;
        }
        else {
            vm.DescriptionToTranslate.StatusId = 17;
        }
        if (vm.NewDescription) {
            HelperService.AddDescription(vm.DescriptionToTranslate)
            .then(function (data) {
                vm.NewDescription = !$rootScope.NewDescriptionTranslationIsAdded;
            });
        }
        else {
            if (vm.SelectedDescriptionStatusItem != vm.PreviousDescriptionStatusItem) {
                vm.PreviousDescriptionStatusItem = vm.SelectedDescriptionStatusItem;
                HelperService.UpdateDescription(vm.DescriptionToTranslate)
                    .then(function (data) {

                    });
            }
        }
    }

    vm.GetDescriptionTranslated = function () {
        HelperService.GetDescriptionById(vm.quartier.DescriptionList[vm.ActiveDescriptionId].DescriptionId, $rootScope.LangForTranslationDestination)
                                .then(function (desc) {
                                    if (desc.success == false) {
                                        vm.DescriptionToTranslate = angular.copy(vm.quartier.DescriptionList[vm.ActiveDescriptionId]);
                                        vm.DescriptionToTranslate.LanguageCode = $rootScope.LangForTranslationDestination;
                                        vm.DescriptionToTranslate.IsDefaultLang = false;
                                        vm.DescriptionToTranslate.DescriptionTitle = '';
                                        vm.DescriptionToTranslate.Stick = '';
                                        vm.DescriptionToTranslate.Resume = '';
                                        vm.DescriptionToTranslate.Description = '';
                                        vm.DescriptionToTranslate.StatusTrad = $translate.instant("StatusId25");
                                        //init status
                                        vm.SelectedDescriptionStatusItem = $rootScope.StatusList4WorkflowDescriptionTranslationIdValue[0];
                                        vm.PreviousDescriptionStatusItem = angular.copy(vm.SelectedDescriptionStatusItem);
                                        vm.NewDescription = true;

                                    }
                                    else {
                                        vm.DescriptionToTranslate = desc;
                                        vm.SelectedDescriptionStatusItem = GetItemByFieldName(vm.DescriptionToTranslate.StatusId, 'id', $rootScope.StatusList4WorkflowDescriptionTranslationIdValue)[0];
                                        vm.PreviousDescriptionStatusItem = angular.copy(vm.SelectedDescriptionStatusItem);
                                        vm.NewDescription = false;
                                    }

                                });
    };


    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVm(vm.quartier.DescriptionList[vm.ActiveDescriptionId].DescriptionId, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
            });
    }

    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/traduction/district?id=' + vm.quartier.District.DistrictId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }

    vm.PreviousDesc = function () {
        if (vm.quartier.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            vm.GetDescriptionVm();
            vm.GetDescriptionTranslated();
        }
    }

    vm.NextDesc = function () {
        if (vm.quartier.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.quartier.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            vm.GetDescriptionVm();
            vm.GetDescriptionTranslated();
        }
    }

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null: $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "District", (lastelement == null ? 0: lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                      },
                function error(data) {
                });
                };



    $scope.TranslateDescription = function TranslateDescription() {
        DistrictService.TranslateDescription(vm.quartier, $scope.CurrentLang, $rootScope.LangForTranslationDestination, 0);
    };

    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, $rootScope.EnumLinkType.District);
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment(vm.quartier.SideBar.CommentEdit, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, $rootScope.EnumLinkType.District);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        promiseAddComment = DistrictService.SaveDiffuseur(vm.quartier.ClientList, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);
    };

    $rootScope.SaveAdressesAssociees = function SaveAdressesAssociees() {

        promiseAddComment = DistrictService.SaveAdressesAssociees(vm.quartier.PlaceList, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);
    };

    $rootScope.SaveClassification = function SaveClassification() {

        promiseAddComment = DistrictService.SaveClassification(vm.quartier.ClassificationList, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);
    };


    // Fin  SideBar method
 

    $scope.dropdownDescIsOpen = false;

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.updateFieldTags = function () {
        $scope.$emit('updateFieldTags');
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailShareDistrictPracticalInfo', $translate.instant('emailShareDistrictPracticalInfo').replaceAll('&amp;', '&'), vm.quartier);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }
};